import {KEY_POINT_INCOME} from "../../../configs/income";
import {isPlayerPolicy} from "../../factions/isPlayerPolicy";
import {POLICIES} from "../../../constants/policies";
import {TOKENS} from "../../../constants/tokens";
import {isNeighborOrSameHexKeys} from "../../coords/isNeighborOrSameHexKeys";
import {checkIfHexBlockedByEnemyUnit} from "../checkIfHexBlockedByEnemyUnit";
import {
  POLICY_SERVARIANISM_BARRACKS_BONUS_COINS_INCOME,
  POLICY_SERVARIANISM_UNIT_BONUS_COINS_INCOME,
  POLICY_SERVARIANISM_UNIT_BONUS_SIZE_THRESHOLD
} from "../../../configs/policy/servarianism";
import {getPlayerUnits} from "../../players/getPlayerUnits";

/**
 * Доход рудника по слагаемым — для расшифровки дохода игрока (панель статов
 * в шапке); calcMineIncome — их сумма
 * @returns {{base: number, servarianismBarracks: number, servarianismUnit: number, total: number}}
 */
export const calcMineIncomeDetails = (mineHexKey, mineToken, player, citiesCache, units, hexes, specialBuildings, buildingsDamage) => {
  let servarianismBarracks = 0;
  let servarianismUnit = 0;

  if (isPlayerPolicy(player, POLICIES.SERVARIANISM)) {
    // Каждая категория дает бонус руднику не более ОДНОГО раза: +1 за наличие
    // хотя бы одной смежной рабочей казармы (сколько бы их ни было и из скольких
    // бы городов они ни были) и +1 за наличие хотя бы одного смежного отряда
    // порогового размера. Максимум суммарно +2 на рудник.
    const hasAdjacentWorkingBarracks = (citiesCache[player.color] || []).some((city) =>
      (city[TOKENS.BARRACKS] || []).some((hexKey) =>
        isNeighborOrSameHexKeys(mineHexKey, hexKey)
        && !checkIfHexBlockedByEnemyUnit(hexKey, TOKENS.BARRACKS, player.id, units, hexes, specialBuildings, buildingsDamage)
      )
    );
    if (hasAdjacentWorkingBarracks) {
      servarianismBarracks = POLICY_SERVARIANISM_BARRACKS_BONUS_COINS_INCOME;
    }

    const hasAdjacentThresholdUnit = getPlayerUnits(player, units).some((unit) =>
      unit.size >= POLICY_SERVARIANISM_UNIT_BONUS_SIZE_THRESHOLD
      && isNeighborOrSameHexKeys(mineHexKey, unit.hexKey)
    );
    if (hasAdjacentThresholdUnit) {
      servarianismUnit = POLICY_SERVARIANISM_UNIT_BONUS_COINS_INCOME;
    }
  }

  const base = KEY_POINT_INCOME[mineToken];
  return {
    base,
    servarianismBarracks,
    servarianismUnit,
    total: base + servarianismBarracks + servarianismUnit,
  };
};

export const calcMineIncome = (mineHexKey, mineToken, player, citiesCache, units, hexes, specialBuildings, buildingsDamage) => (
  calcMineIncomeDetails(mineHexKey, mineToken, player, citiesCache, units, hexes, specialBuildings, buildingsDamage).total
);
